import request from '@/utils/request'

//  获取阿里文档token
export function getAliToken(data) {
  return request({
    url: '/system/ali/imm/gen-token',
    method: 'post',
    data
  })
}

//  刷新阿里文档token
export function refreshAliToken(data) {
  return request({
    url: '/system/ali/imm/refresh-token',
    method: 'post',
    data
  })
}

// 通过storageId 获取到阿里云源地址
export function getAliUrl(data) {
  return request({
    url: '/system/study/center/toolkit/queryFiles',
    method: 'post',
    data
  })
}
